// TODO: move this util to consumer-web-scripts repo so that it can be reused across projects
/**
 * Extracts the optimal message from a server error response. The `response` object is the
 * stringified Error, and the outer `message` is the general message based on http status
 * @param {Object} error
 */
export default function getErrorMessage(error, defaultMessage) {
  const message = error?.response?.body?.message || error?.response?.message // Server error message
    || defaultMessage // Optionally provided default error message
    || error?.message // Generic error based on http status code
    || 'An error occurred'; // Fallback error message

  // Message will always have a value, so only return if error is truthy.
  return error && message;
}
